import { INTENT_TYPES } from 'v2/common/constants/index';
import { getDefaultIdentifier, IDENTIFIER_TYPES } from 'v2/modules/withRunForm/configs/index';
import { getTypeBasedValue } from './config';

export const moveToCostBasedAdjustmentAdder = (
  intents, intent, lastAdjustmentConfigIndex, moveToCostOptionIndexes
) => {
  const {
    identifier: { segment, label, caseIndex },
    stopLoss,
    instrument: { instrumentIndex }
  } = intent;

  const findLabelByOptionIndex = (optionIndex) => {
    return intents.find(({ identifier }) => identifier.optionConfigIndex === optionIndex
      && identifier.adjustmentConfigIndex === null
      && identifier.instrumentIndex === instrumentIndex
      && identifier.caseIndex === caseIndex)?.identifier?.label;
  };

  return moveToCostOptionIndexes.map((moveToCostOptionIndex) => {
    const newLeftOperand = `case.${caseIndex}.leg.${label}.${getTypeBasedValue(stopLoss?.type)}`;

    const newIdentifier = {
      ...getDefaultIdentifier(caseIndex, IDENTIFIER_TYPES.case),
      type: 'Legacy',
      segment,
      caseIndex,
      adjustmentConfigIndex: lastAdjustmentConfigIndex,
      instrumentIndex,
      optionConfigIndex: moveToCostOptionIndex,
    };

    const newTarget = {
      type: 'Legacy',
      label: findLabelByOptionIndex(moveToCostOptionIndex),
      iteration: 0,
      segment,
      caseIndex,
      adjustmentConfigIndex: null,
      instrumentIndex,
      optionConfigIndex: moveToCostOptionIndex,
    };

    return {
      uiConfigs: {
        isAutoAdjustment: true,
        adjustmentMode: 'moveToCost',
      },
      signal: [
        {
          conditionOperator: '',
          leftOperand: newLeftOperand,
          operator: 'equalOrAbove',
          rightOperand: stopLoss?.value,
        },
      ],
      intents: [
        {
          type: INTENT_TYPES.UpdateStopLoss,
          target: newTarget,
          identifier: newIdentifier,
        },
      ],
    };
  });
};
